export default {"src":"/_next/static/media/arrow-down.d5b84b5e.svg","height":5,"width":8,"blurWidth":0,"blurHeight":0};